<template>
  <!-- маленькая, белый фон -->
  <svg  v-if="typeImg === 'mini'" width="42" height="40" viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="42" height="40" rx="6" fill="black" fill-opacity="0.35"/>
    <path d="M21 23.5C24.4518 23.5 27.25 20.7018 27.25 17.25C27.25 13.7982 24.4518 11 21 11C17.5482 11 14.75 13.7982 14.75 17.25C14.75 20.7018 17.5482 23.5 21 23.5ZM21 23.5C15.4772 23.5 11 26.8579 11 31M21 23.5C26.5228 23.5 31 26.8579 31 31" stroke="white" stroke-opacity="0.35" stroke-width="2" stroke-linecap="round"/>
    </svg>

  <!-- маленькая, синий фон -->
  <svg v-if="typeImg === 'miniBlue'" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="mdi:account-circle" clip-path="url(#clip0_1428_37559)">
      <path id="Vector" d="M15 25.8C11.25 25.8 7.935 23.88 6 21C6.045 18 12 16.35 15 16.35C18 16.35 23.955 18 24 21C23.0083 22.4766 21.6688 23.6867 20.0993 24.5238C18.5299 25.3608 16.7787 25.7991 15 25.8ZM15 4.5C16.1935 4.5 17.3381 4.97411 18.182 5.81802C19.0259 6.66193 19.5 7.80653 19.5 9C19.5 10.1935 19.0259 11.3381 18.182 12.182C17.3381 13.0259 16.1935 13.5 15 13.5C13.8065 13.5 12.6619 13.0259 11.818 12.182C10.9741 11.3381 10.5 10.1935 10.5 9C10.5 7.80653 10.9741 6.66193 11.818 5.81802C12.6619 4.97411 13.8065 4.5 15 4.5ZM15 0C13.0302 0 11.0796 0.387987 9.25975 1.14181C7.43986 1.89563 5.78628 3.00052 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C5.78628 26.9995 7.43986 28.1044 9.25975 28.8582C11.0796 29.612 13.0302 30 15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 6.705 23.25 0 15 0Z" fill="#1BA6DA"/>
    </g>
    <defs>
      <clipPath id="clip0_1428_37559">
        <rect width="30" height="30" fill="white"/>
      </clipPath>
    </defs>
  </svg>

  <!-- синий фон, большая-->

  <svg v-if="typeImg === 'big'" width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="96" height="96" rx="13.7143" fill="#00ABEC"/>
    <path d="M47.9997 53.714C55.8895 53.714 62.2854 47.3181 62.2854 39.4283C62.2854 31.5385 55.8895 25.1426 47.9997 25.1426C40.1099 25.1426 33.714 31.5385 33.714 39.4283C33.714 47.3181 40.1099 53.714 47.9997 53.714ZM47.9997 53.714C35.3761 53.714 25.1426 61.3891 25.1426 70.8569M47.9997 53.714C60.6234 53.714 70.8569 61.3891 70.8569 70.8569" stroke="white" stroke-width="4.57143" stroke-linecap="round"/>
    </svg>
</template>

<script>

export default {
  name: 'PersonIcon',
  props: {
    typeImg: {
      type: String,
      default: 'mini'
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
